/* Reliva carousel: arrows, dots, swipe with snapping. Markup: <div class="car" data-car><div class="car-track">cards...</div></div> */
(function () {
  function init(car) {
    if (car._rl) return; car._rl = 1;
    var tr = car.querySelector('.car-track'); if (!tr) return;
    var cards = [].slice.call(tr.children);
    var prev = document.createElement('button'), next = document.createElement('button');
    prev.type = next.type = 'button'; prev.className = 'car-btn prev'; next.className = 'car-btn next';
    prev.setAttribute('aria-label', 'Назад'); next.setAttribute('aria-label', 'Напред');
    prev.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>';
    next.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg>';
    car.appendChild(prev); car.appendChild(next);
    var dots = document.createElement('div'); dots.className = 'car-dots'; car.appendChild(dots);
    tr.setAttribute('tabindex', '0'); tr.setAttribute('role', 'region');
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    function step() { var a = cards[0], b = cards[1]; return b ? b.offsetLeft - a.offsetLeft : a.offsetWidth; }
    function pages() { var s = step() || 1, vis = Math.max(1, Math.round(tr.clientWidth / s)); return Math.max(1, cards.length - vis + 1); }
    function buildDots() {
      var n = pages(); if (dots._n === n) return; dots._n = n; dots.innerHTML = '';
      dots.style.display = n > 1 ? '' : 'none';
      for (var i = 0; i < n; i++) { (function (i) { var d = document.createElement('button'); d.type = 'button'; d.className = 'car-dot'; d.setAttribute('aria-label', 'Към карта ' + (i + 1)); d.onclick = function () { go(i); }; dots.appendChild(d); })(i); }
    }
    function idx() { return Math.min(pages() - 1, Math.max(0, Math.round(tr.scrollLeft / (step() || 1)))); }
    function go(i) { tr.scrollTo({ left: i * step(), behavior: reduce ? 'auto' : 'smooth' }); }
    function upd() {
      buildDots(); var i = idx(), max = tr.scrollWidth - tr.clientWidth - 2;
      [].forEach.call(dots.children, function (d, k) { d.classList.toggle('on', k === i); if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      prev.disabled = tr.scrollLeft <= 2; next.disabled = tr.scrollLeft >= max;
      car.classList.toggle('single', tr.scrollWidth <= tr.clientWidth + 2);
    }
    prev.onclick = function () { go(Math.max(0, idx() - 1)); };
    next.onclick = function () { go(Math.min(pages() - 1, idx() + 1)); };
    tr.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
    tr.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); next.click(); } if (e.key === 'ArrowLeft') { e.preventDefault(); prev.click(); } });
    window.addEventListener('resize', function () { dots._n = 0; upd(); });
    upd(); setTimeout(upd, 400);
  }
  function all() { [].forEach.call(document.querySelectorAll('[data-car]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  window.addEventListener('load', all);
})();
